import { universalFetch } from 'core/fetch';
import { ANBIETER_API_PREFIX } from 'utils/enums';
import AccountClient from './AccountClient';

const accountClient = new AccountClient({
  fetch: universalFetch,
  prefix: ANBIETER_API_PREFIX,
}) as unknown as {
  fetchRealtorData: (cwid: any) => Promise<any>;
  fetchRealtors: (query: any) => Promise<any>;
  fetchRealtorMandatoryFields: (cwid: string) => Promise<any>;
};

export default accountClient;
